import type { IContainer } from '@monofe/di';
import { injectOrBuildContainer } from '@monofe/di';
import type { IAuthManagerInstantiator } from './auth';
import type { IMediaManagerInstantiator } from './media';
import type { IUserStateInstantiator } from './userstate';

export const TYPES = {
    IAuthenticationManager: Symbol.for('IAuthenticationManager'),
    IMediaManager: Symbol.for('IMediaManager'),
    IUserStateManager: Symbol.for('IUserStateManager'),
};

export function injectMediaManager(
    container: IContainer = injectOrBuildContainer(),
): IMediaManagerInstantiator {
    return container.get<IMediaManagerInstantiator>(TYPES.IMediaManager);
}

export function bindMediaManager(
    val: IMediaManagerInstantiator,
    container: IContainer = injectOrBuildContainer(),
): void {
    container.bind<IMediaManagerInstantiator>(TYPES.IMediaManager, val);
}

export function unbindMediaManager(container: IContainer = injectOrBuildContainer()): void {
    container.remove(TYPES.IMediaManager);
}

export function injectAuthManager(
    container: IContainer = injectOrBuildContainer(),
): IAuthManagerInstantiator {
    return container.get<IAuthManagerInstantiator>(TYPES.IAuthenticationManager);
}

export function bindAuthManager(
    val: IAuthManagerInstantiator,
    container: IContainer = injectOrBuildContainer(),
): void {
    container.bind<IAuthManagerInstantiator>(TYPES.IAuthenticationManager, val);
}

export function unbindAuthManager(container: IContainer = injectOrBuildContainer()): void {
    container.remove(TYPES.IAuthenticationManager);
}

export function injectUserStateManager(
    container: IContainer = injectOrBuildContainer(),
): IUserStateInstantiator {
    return container.get<IUserStateInstantiator>(TYPES.IUserStateManager);
}

export function bindUserStateManager(
    val: IUserStateInstantiator,
    container: IContainer = injectOrBuildContainer(),
): void {
    container.bind<IUserStateInstantiator>(TYPES.IUserStateManager, val);
}

export function unbindUserStateManager(container: IContainer = injectOrBuildContainer()): void {
    container.remove(TYPES.IUserStateManager);
}
